import { memo } from 'react';
import { css } from '@emotion/react';
import { Chip } from '@frontend/design-system';
import { CALENDAR_Z_INDICES } from '../constants';
import { useCalendarGridStore } from '../store/calendar-grid.store';

export const BaseTimeZoneChipCell = memo(() => {
  const baseTimezone = useCalendarGridStore((state) => state.groupsById[state.groupIds[0]]?.timezone);

  if (!baseTimezone) return null;

  return (
    <div data-timezone-chip-cell css={containerStyle}>
      <Chip.TimeZone>{baseTimezone}</Chip.TimeZone>
    </div>
  );
});

BaseTimeZoneChipCell.displayName = 'BaseTimeZoneChipCell';

// row 3 is the spacer row, directly below the all-day toggle icon in row 2
const containerStyle = css({
  gridColumn: 1,
  gridRow: 3,
  position: 'sticky',
  left: 0,
  zIndex: CALENDAR_Z_INDICES.topCornerCell,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  userSelect: 'none',
  maxWidth: 'var(--time-column-width)',
});
